export default {
  years: 'an | ans',
  months: 'mois',
  weeks: 'semaine | semaines',
  days: 'jour | jours',
  hours: 'heure | heures',
  minutes: 'minute | minutes',
  seconds: 'seconde | secondes'
}
